import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import PrimeVue from 'primevue/config';
//import Button from 'primevue/button';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
import store from './store/vuex'
import VeeValidate from 'vee-validate'
import Dictionary from '@/assets/validators'
import vuetify from './plugins/vuetify'


/** NOTIFICATIONS  */
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const options = {
    transition: "Vue-Toastification__fade",
	maxToasts: 20,
	newestOnTop: true
};
Vue.use(Toast, options);

Vue.use(TiptapVuetifyPlugin, {
	// the next line is important! You need to provide the Vuetify Object to this place.
	vuetify, // same as "vuetify: vuetify"
	// optional, default to 'md' (default vuetify icons before v2.0.0)
	iconsGroup: 'mdi'
})

import './assets/custom.css'


Vue.config.productionTip = false


const veeValidateConfig = {
	inject: true,
	fieldsBagName: 'veeFields',
	errorBagName: 'veeErrors',
	classes: true,
	classNames: {
		valid: 'is-valid',
		invalid: 'is-invalid'
	},
	locale:'pt',
	dictionary: Dictionary
}

Vue.use(VeeValidate, veeValidateConfig)

Vue.filter('formatarData',function(val){
	return new Date(val).toLocaleString()
})
Vue.filter('truncate_file_text', function (value, size) {
	if (!value) return '';
	value = value.toString();
	
	if (value.length <= size) {
		return value;
	}
	return '...'+value.substr(value.length-size, size);
});

Vue.filter('truncate', function (value, size) {
	if (!value) return '';
	value = value.toString();
	
	if (value.length <= size) {
		return value;
	}
	return value.substr(0, size)+'...';
});


new Vue({
	router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
